
/**
 * @author Sascha Dobschal <s.dobschal@tdsoftware.de>
 * date 07/16/2018
 * Information: http://kazupon.github.io/vue-i18n/guide/started.html
 */

export default {
    en: {
        contact:
        {
            sent: "Thanks for your Message!",
            error:
            {
                send: "Error while sending message!"
            }
        },
        withdrawal:
        {
            title: "Withdraw from contract",
            description: "<p>As a consumer you have the right to withdraw from this contract within 14 days without giving any reason. The withdrawal period is 14 days from the day on which you, or a third party named by you who is not the carrier, took possession of the goods.</p><p>To exercise your right of withdrawal, you must inform us (edition bohemica, Andreas W. Petrak, info@edition-bohemica.de) by means of a clear statement (e.g. a letter sent by post or an e-mail) of your decision to withdraw from this contract. You may use the form below, but it is not mandatory. To meet the withdrawal deadline, it is sufficient that you send your notice before the withdrawal period has expired.</p><p>If you withdraw from this contract, we will reimburse all payments received from you without undue delay and at the latest within 14 days. After submitting the form you will receive a confirmation of receipt by e-mail.</p>",
            name: "Name",
            orderId: "Order number",
            email: "E-Mail",
            emailInfo: "Please use the e-mail address you used for your order. You will receive a confirmation of receipt at this address.",
            submit: "Send withdrawal",
            sent: "Your withdrawal has been received. You will shortly receive a confirmation by e-mail.",
            error:
            {
                send: "Error while sending the withdrawal. Please try again later."
            }
        },
        cart:
        {
            info: "After submitting the form you will get an email with the payment information.",
            realyDelete: "Do you want to remove the product from the cart?",
            title: "Cart",
            error:
            {
                empty: "You have no products in your cart.",
                calc: "While calculating the price an error occurred!"
            }
        },
        product:
        {
            toDetails: "To the product details...",
            orderNow: "Order Now",
            checkout:
            {
                waitInfo: "Please wait. Your is being processed...",
                addedToCart: "Product is now in your cart.",
                amountInfo: "The product is already in your cart. If you want to order more than one, you can change the amount while finishing your order.",
                countryInfo: "Die Versandkosten für eine Zustellung außerhalb Deutschlands werden separat berechnet. Sie erhalten nach Abschluss des Bestellvorgangs eine E-Mail mit allen Informationen.",
                title: "Finish order",
                name: "Name",
                email: "E-Mail",
                street: "Street",
                houseNumber: "House number",
                zipCode: "Postal Code",
                city: "City",
                country: "Country",
                comment: "Comment",
                submit: "Send order",
                emailInfo: "All order information will be send to this e-mail address.",
                submitError: "Error while sending order. Please try again later.",
                submitMessage: "Thank you for your order. You will receive an e-mail with all further information. Your order number is: "
            }
        },
        contentId:
        {
            'dashboard-title': "Dashboard title",
            'dashboard-content': "Dashboard content",
            "news-content": "News",
            "agb-content": "AGB",
            "imprint-content": "Impressum",
            "data-security-content": "Datenschutz",
            "portrait-content": "Portrait",
            "travel-content": "Travel to Bohemica",
            "trader-content": "Trader"
        },
        general: {
            isInPreparation: "Is in preparation?",
            captchaMessage: "Please check the captcha.",
            mathChallenge: "Anti-Spam: What is {a} + {b}?",
            contact: "Contact",
            send: "Send",
            yourMessage: "Your Message",
            sender: "Sender (E-Mail)",
            zoomIn: "Zoom in",
            zoomOut: "Zoom out",
            download: "Download",
            totalPrice: "Total price",
            deleteSuccessful: "Deleted successfully",
            delete: "Delete",
            amount: "Anzahl",
            porto: "Porto",
            portoFree: "None",
            addToCart: "Add to cart",
            hasPorto: "Has porto costs?",
            isPublic: "Is public?",
            additionalInfo: "Addtional information",
            userInfo: "Amount of page visits.",
            weight: "Weight in gramm",
            back: "back",
            edit: "edit",
            actions: "Actions",
            publish: "publish",
            unpublish: "hide",
            public: "Public",
            yes: "Yes",
            no: "No",
            username: "Username",
            password: "Password",
            login: "Login",
            title: "Title",
            subtitle: "Subtitle",
            description: "Description",
            price: "Price",
            image: "Image",
            saveInProgress: "Saving in progress...",
            saveSuccessful: "Saving was successful.",
            save: "Save",
            cancel: "Cancel",
            upload: "Upload",
            error: {
                pageNotFound: "Sorry! Page not found.",
                unauthorized: "Sorry! Please login first!",
                missingInput: "The input values are not valid.",
                save: "Error while saving data.",
                delete: "Error while deleting data.",
                load: "Error while loading data!",
                priceFormat: "Price needs to be a number",
                mathChallenge: "The result of the calculation is wrong. Please try again."
            }
        },
        navigation: {
            correspondence: "Verlags-Correspondenz",
            porto: "Porto",
            start: "The Shop",
            shop: "Shop",
            news: "News",
            program: "Program",
            images: "Image treasure",
            travel: "Travel to Bohemia",
            portrait: "Portrait",
            imprint: "Imprint",
            login: "Login",
            logout: "Logout",
            admin: "Produkte",
            newProduct: "New Product",
            contents: "Contents",
            comingSoon: "Coming Soon",
            trader: "Trader",
            data: "Datenschutz",
            agb: "AGB",
            pdf: "Upload PDF",
            withdrawal: "Withdraw from contract"
        },
        comingSoon:
        {
            info: "Have a view on our upcoming titles..."
        },
        login: {
            title: "Login",
            success: "You are now authenticated.",
            error: "Username or password are wrong."
        },
        dashboard: {
            title: "edition bohemica",
            toNews: "To the news",
            toCart: "To the cart",
            productTitle: "Available Products"
        },
        backend: {
            pdf:
            {
                title: "PDF Bearbeiten",
                pdfUpload: "PDF die angezeigt werden soll, wenn der Nutzer die Seite öffnet."
            },
            porto:
            {
                title: "Porto"
            },
            contents:
            {
                title: "Inhalte"
            },
            editContent:
            {
                title: "Texte Bearbeiten"
            },
            overview:
            {
                addProduct: "Add Product",
                title: "Admin Area",
                products: "Products",
                sort: "Products sorted.",
                productsInPreparation: "Products in preparation",
                publicProducts: "Products in store",
                error: {
                    load: "Error! Unable to load products.",
                    sort: "Error! Unable to sort products.",
                    publish: "Error! Unable to publish product.",
                    delete: "Error! Unable to delete product."
                }
            },
            newProduct:
            {
                title: "New Product"
            },
            editProduct:
            {
                title: "Change Product"
            }
        }
    },
    de: {
        contact:
        {
            sent: "Danke für Ihre Nachricht!",
            error:
            {
                send: "Fehler! Nachricht konnte nicht gesendet werden!"
            }
        },
        withdrawal:
        {
            title: "Vertrag widerrufen",
            description: "<p>Sie haben als Verbraucher das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.</p><p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (edition bohemica, Andreas W. Petrak, info@edition-bohemica.de) mittels einer eindeutigen Erklärung (z.&nbsp;B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das nachfolgende Formular verwenden, das jedoch nicht vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.</p><p>Im Falle eines wirksamen Widerrufs erstatten wir Ihnen alle erhaltenen Zahlungen unverzüglich und spätestens binnen vierzehn Tagen zurück. Nach dem Absenden des Formulars erhalten Sie eine Bestätigung über den Zugang Ihres Widerrufs per E-Mail.</p>",
            name: "Name",
            orderId: "Bestellnummer",
            email: "E-Mail",
            emailInfo: "Bitte verwenden Sie die E-Mail-Adresse, mit der Sie bestellt haben. An diese Adresse senden wir Ihnen die Eingangsbestätigung.",
            submit: "Widerruf absenden",
            sent: "Ihr Widerruf ist bei uns eingegangen. Sie erhalten in Kürze eine Bestätigung per E-Mail.",
            error:
            {
                send: "Beim Senden des Widerrufs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
            }
        },
        cart:
        {
            info: "Nach dem Absenden der Bestellung erhalten Sie eine E-Mail mit der Bestellbestätigung und den Bezahlinformationen.",
            title: "Warenkorb",
            realyDelete: "Wollen Sie den Artikel aus dem Warenkorb entfernen?",
            error:
            {
                empty: "Sie haben aktuell keine Produkte in Ihrem Warenkorb.",
                calc: "Beim Berechnen des Preises ist ein Fehler aufgetreten!"
            }
        },
        product:
        {
            toDetails: "Zu den Produkt-Details...",
            orderNow: "Jetzt Bestellen",
            checkout:
            {
                waitInfo: "Bitte warten. Ihre Bestellung wird gesendet.",
                addedToCart: "Das Produkt wurde in Ihren Warenkorb gelegt.",
                amountInfo: "Das Produkt befindet sich bereits in Ihrem Warenkorb. Falls Sie mehrere Exemplare bestellen wollen, können Sie dies später während der Bestellung angeben.",
                countryInfo: "Die Versandkosten für eine Zustellung außerhalb Deutschlands werden separat berechnet. Sie erhalten nach Abschluss des Bestellvorgangs eine E-Mail mit allen Informationen.",
                title: "Bestellung abschließen",
                name: "Name",
                email: "E-Mail",
                street: "Straße",
                houseNumber: "Hausnummer",
                zipCode: "Postleitzahl",
                city: "Stadt",
                country: "Land",
                comment: "Kommentar",
                submit: "Bestellung abschicken",
                emailInfo: "Alle Bestellinformationen werden an diese E-Mail gesendet.",
                submitError: "Beim Senden der Bestellung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
                submitMessage: "Vielen Dank für Ihre Bestellung! Sie erhalten in wenigen Momenten eine E-Mail mit ihrer Bestellbestätigung. <br><br>Ihre Bestellnummer lautet: "
            }
        },
        contentId:
        {
            'dashboard-title': "Begrüßung Startseite",
            'dashboard-content': "Text Startseite",
            "news-content": "Aktuelles",
            "agb-content": "AGB",
            "imprint-content": "Impressum",
            "data-security-content": "Datenschutz",
            "portrait-content": "Verlagsportrait",
            "travel-content": "Reisewege nach Böhmen",
            "trader-content": "Händler"
        },
        general: {
            isInPreparation: "Ist in Vorbereitung?",
            captchaMessage: "Bitte bestätigen Sie, dass Sie kein Roboter sind.",
            mathChallenge: "Spam-Schutz: Was ergibt {a} + {b}?",
            contact: "Kontakt",
            send: "Abschicken",
            yourMessage: "Ihre Nachricht",
            sender: "Absender (E-Mail)",
            zoomIn: "Vergrößern",
            zoomOut: "Verkleinern",
            download: "Herunterladen",
            totalPrice: "Gesamtpreis",
            deleteSuccessful: "Erfolgreich gelöscht",
            delete: "Löschen",
            amount: "Anzahl",
            porto: "Versandkosten",
            portoFree: "keine",
            addToCart: "Zum Warenkorb hinzufügen",
            hasPorto: "Fallen Versandkosten an?",
            isPublic: "Ist öffentlich?",
            additionalInfo: "Weitere Informationen",
            userInfo: "Anzahl der Seitenaufrufe.",
            weight: "Gewicht in Gramm",
            back: "Zurück",
            edit: "Bearbeiten",
            actions: "Aktionen",
            publish: "Veröffentlichen",
            unpublish: "Verstecken",
            public: "Öffentlich",
            yes: "Ja",
            no: "Nein",
            username: "Benutzername",
            password: "Passwort",
            login: "Anmelden",
            title: "Titel",
            subtitle: "Untertitel",
            description: "Beschreibung",
            price: "Preis",
            image: "Bild",
            saveInProgress: "Inhalt wird gerade gespeichert...",
            saveSuccessful: "Speichern war erfolgreich.",
            save: "Speichern",
            cancel: "Abbrechen",
            upload: "Hochladen",
            error: {
                pageNotFound: "Entschuldigung! Die Seite wurde nicht gefunden.",
                unauthorized: "Entschuldigung! Bitte melden Sie sich zunächst an.",
                missingInput: "Es sind nicht alle Felder korrekt ausgefüllt.",
                save: "Beim Speichern ist ein Fehler aufgetreten.",
                delete: "Beim Löschen ist ein Fehler aufgetreten.",
                load: "Beim Laden der Daten ist ein Fehler aufgetreten!",
                priceFormat: "Der Preis muss eine Zahl sein. Z.B. 19,50 oder 500",
                mathChallenge: "Das Ergebnis der Rechenaufgabe ist nicht korrekt. Bitte versuchen Sie es erneut."
            }
        },
        navigation: {
            correspondence: "Verlags-Correspondenz",
            porto: "Versandkosten",
            start: "Der Laden",
            shop: "Laden",
            news: "Aktuelles",
            program: "Verlagsprogramm",
            images: "Bilderschatztruhe",
            travel: "Reisewege nach Böhmen",
            portrait: "Verlagsportrait",
            imprint: "Impressum",
            login: "Anmelden",
            logout: "Abmelden",
            admin: "Produkte verwalten",
            newProduct: "Neues Produkt",
            contents: "Inhalte verwalten",
            comingSoon: "In Vorbereitung",
            trader: "Händler",
            data: "Datenschutz",
            agb: "AGB",
            pdf: "PDFs hochladen",
            withdrawal: "Vertrag widerrufen"
        },
        comingSoon:
        {
            info: "Anbei finden Sie Titel, die sich aktuell in der Vorbereitung befinden."
        },
        login: {
            title: "Anmeldung",
            success: "Sie sind nun angemeldet.",
            error: "Benutzername oder Passwort sind leider falsch!"
        },
        dashboard: {
            title: "edition bohemica",
            toNews: "Zu Aktuelles",
            toCart: "Zum Warenkorb",
            productTitle: "Lieferbare Titel"
        },
        backend: {
            pdf:
            {
                title: "PDF Bearbeiten",
                pdfUpload: "PDF die angezeigt werden soll, wenn der Nutzer die Seite öffnet."
            },
            porto:
            {
                title: "Versandkosten"
            },
            contents:
            {
                title: "Inhalte"
            },
            editContent:
            {
                title: "Texte Bearbeiten"
            },
            overview:
            {
                sort: "Produkte wurden sortiert.",
                addProduct: "Produkt hinzufügen",
                title: "Admin-Bereich",
                products: "Produkte",
                productsInPreparation: "Produkte in Vorbereitung",
                publicProducts: "Produkte im Laden",
                error: {
                    load: "Fehler! Konnte Produkte nicht laden.",
                    sort: "Fehler! Sortierung konnte nicht gespeichert werden!",
                    publish: "Fehler! Produkt konnte nicht veröffentlicht werden!",
                    delete: "Fehler! Produkt konnte nicht gelöscht werden!"
                }
            },
            newProduct:
            {
                title: "Neues Produkt"
            },
            editProduct:
            {
                title: "Produkt bearbeiten"
            }
        }
    },
    cs: {

    }
};



// WEBPACK FOOTER //
// ./src/config/dictionary.js